import { LRST_ADDRESS, USDT_ADDRESS, USDC_ADDRESS, BTCB_ADDRESS, ETH_ADDRESS } from './contracts';

// Coingecko token mapping untuk BSC
const COINGECKO_IDS = {
  'BNB': 'binancecoin',
  'USDT': 'tether',
  'USDC': 'usd-coin',
  'ETH': 'ethereum',
  'BTCB': 'bitcoin',
  'WBNB': 'wbnb'
};

// Helper function to get Coingecko logo URL
export const getCoingeckoLogo = (symbol) => {
  const coingeckoId = COINGECKO_IDS[symbol?.toUpperCase()];
  if (!coingeckoId) return null;
  
  // Coingecko CDN for token images
  return `https://assets.coingecko.com/coins/images/large/${coingeckoId}.png`;
};

// Fallback logos if Coingecko fails
const FALLBACK_LOGOS = {
  'BNB': '/assets/logo/bnb.png',
  'LRST': '/assets/logo-chart-new.png',
  'USDT': '/assets/logo/usdt.png',
  'USDC': '/assets/logo/usdc.png',
  'ETH': '/assets/logo/eth.png',
  'BTCB': '/assets/logo/btcb.png'
};

export const TOKEN_LIST = [
  {
    symbol: 'BNB',
    name: 'BNB',
    address: 'native',
    decimals: 18,
    isNative: true,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1839.png',
    coingeckoId: 'binancecoin'
  },
  {
    symbol: 'LRST',
    name: 'Little Rabbit Staking Token',
    address: LRST_ADDRESS,
    decimals: 18,
    isNative: false,
    logo: '/assets/logo-rabbit.png',
    coingeckoId: null
  },
  {
    symbol: 'USDT',
    name: 'Tether USD',
    address: USDT_ADDRESS,
    decimals: 18,
    isNative: false,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/825.png',
    coingeckoId: 'tether'
  },
  {
    symbol: 'USDC',
    name: 'USD Coin',
    address: USDC_ADDRESS,
    decimals: 18,
    isNative: false,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png',
    coingeckoId: 'usd-coin'
  },
  {
    symbol: 'ETH',
    name: 'Ethereum (BEP20)',
    address: ETH_ADDRESS,
    decimals: 18,
    isNative: false,
    logo: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
    coingeckoId: 'ethereum'
  }
];

export const getTokenByAddress = (address) => {
  if (!address) return null;
  const addr = address.toLowerCase();
  if (addr === 'native') return TOKEN_LIST[0];
  return TOKEN_LIST.find(t => t.address.toLowerCase() === addr);
};

export const getTokenBySymbol = (symbol) => {
  if (!symbol) return null;
  return TOKEN_LIST.find(t => t.symbol.toUpperCase() === symbol.toUpperCase());
};

// Get token logo with fallback
export const getTokenLogo = (token) => {
  if (!token) return null;
  
  // Use token's logo if available
  if (token.logo) return token.logo;
  
  // Try Coingecko
  const coingeckoLogo = getCoingeckoLogo(token.symbol);
  if (coingeckoLogo) return coingeckoLogo;
  
  // Fallback to local logo
  return FALLBACK_LOGOS[token.symbol] || '/assets/logo/default-token.png';
};
